











































































import { Vue, Component, Prop } from 'vue-property-decorator';
import Input from '@shared/components/forms/inputs/input/input.vue';
import {
  AccountingReportBundledPayment,
  AccountingReportBundledSale,
  AccountingReportSession,
} from '@accounting/interfaces/accounting-reports';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import _ from 'lodash';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import Select from '@shared/components/forms/inputs/select/select.vue';
import { accountingReportSessionFormFields } from '@/config/accounting_reports';
import SaleSessionBundledPaymentsTable from '@shared/components/forms/inputs/sale-session-bundled-payments-table/sale-session-bundled-payments-table.vue';
import SaleSessionBundledSalesTable from '@shared/components/forms/inputs/sale-session-bundled-sales-table/sale-session-bundled-sales-table.vue';
import Section from '@shared/components/forms/inputs/section/section.vue';

@Component({
  name: 'bc-report-session-details',
  components: {
    'bpc-select': Select,
    'bpc-input': Input,
    'bpc-input-group': InputGroup,
    'bpc-datepicker': Datepicker,
    'bc-sale-session-bundled-payments-table': SaleSessionBundledPaymentsTable,
    'bc-sale-session-bundled-sales-table': SaleSessionBundledSalesTable,
    'bc-section': Section,
  },
})
export default class ReportSessionDetails extends Vue {
  @Prop({
    type: Object,
    default: () => {
      return {};
    },
  })
  readonly model: AccountingReportSession;

  sessionReport: AccountingReportSession = null;
  bundledPayments: AccountingReportBundledPayment[] = [];
  bundledSales: AccountingReportBundledSale[] = [];
  loading: boolean = false;
  loadingBundledPayments: boolean = false;
  loadingBundledSales: boolean = false;

  get label() {
    return {
      labelAttributes: {
        for: 'input',
      },
      labelClass: {
        'mt-1 mb-1': true,
      },
    };
  }

  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 px-2': true,
        },
      },
    };
  }

  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 px-2': true,
        },
      },
    };
  }

  get col4() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-4 px-2': true,
        },
      },
    };
  }

  get formFields() {
    return accountingReportSessionFormFields;
  }

  async getReportSession() {
    this.loading = true;
    const modelId = this.model?.id;
    const origin = _.kebabCase(this.model?.origin);
    const baseUrl = this.$bpcApiRouteHelper.getEntityPath('accounting-report');
    const result: BPCGenericApiResponse<AccountingReportSession> = await this.$bpcApi
      .get(`${baseUrl}/session/${origin}/${modelId}`, { params: {} })
      .toPromise();
    this.sessionReport = result.data;
    this.loading = false;
  }

  async getBundledPayments() {
    this.loadingBundledPayments = true;
    const modelId = this.model?.id;
    const origin = _.kebabCase(this.model?.origin);
    const baseUrl = this.$bpcApiRouteHelper.getEntityPath('accounting-report');
    const result: BPCGenericApiResponse<AccountingReportBundledPayment[]> = await this.$bpcApi
      .get(`${baseUrl}/session/${origin}/${modelId}/bundled-payments`, { params: {} })
      .toPromise();
    this.bundledPayments = result.data;
    this.loadingBundledPayments = false;
  }

  async getBundledSales() {
    this.loadingBundledSales = true;
    const modelId = this.model?.id;
    const origin = _.kebabCase(this.model?.origin);
    const baseUrl = this.$bpcApiRouteHelper.getEntityPath('accounting-report');
    const result: BPCGenericApiResponse<AccountingReportBundledSale[]> = await this.$bpcApi
      .get(`${baseUrl}/session/${origin}/${modelId}/bundled-sales`, { params: {} })
      .toPromise();
    this.bundledSales = result.data;
    this.loadingBundledSales = false;
  }

  mounted() {
    this.getReportSession();
    this.getBundledPayments();
    this.getBundledSales();
  }
}
